<template>
  <v-flex xs12 sm12 md12 lg12 xl12>
    <Navbar></Navbar>
    <v-container class="">

      <v-layout row wrap>
        <v-flex sm4 md4 lg3 class="pl-2 ml-2 pt-5" >
          <v-card style="background-color:#2673af">
            <v-card-title>
              <span class="titlecuentos" style="color:white; font-family:Poppins;  font-weight:600">LIBROS</span>
            </v-card-title>
          </v-card>
        </v-flex>

        <v-flex md1 class="pt-5" >
          <v-card flat style="background-color:#D6D6D6">
            <img src="cuentos.png"  style="position:absolute;margin-left:-30px; margin-top:-8px;z-index:1" />
          </v-card>
        </v-flex>
            
        <v-spacer></v-spacer>
        <!--<v-flex xs12 sm4 md4 lg6>
          <v-text-field 
            class="pt-2 mt-4 pa-3 hidden-sm-and-md" 
            solo  
            label="Buscar Cuento"  
            v-model="searchstory" 
            prepend-inner-icon="search"
            style="width:75%;" >
          </v-text-field>
        </v-flex> -->
      </v-layout>

      <v-layout row wrap>
        <v-flex xs12 sm4 md4 lg4 v-for="libro in filterLibros" :key="libro.title">
          <v-card flat class=" pa-3 " style="background-color:#D6D6D6" >
            <v-layout row wrap>
              <v-flex md12>
              <!--<v-layout :class="`actividad ${capacitacion.actividad}`">-->
                <!--<v-card-title class="temacuento">
                  <div class="text-xs-center">
                    <span>{{cuento.title}}</span>
                  </div>
                </v-card-title>-->
              </v-flex>
            </v-layout>
                 
           <!--<a @click="downloadItem(cuento.url,cuento.namedownload)"> -->
             <a title="Demo" subtitle="Test"  :href="libro.url" target="_blank"> 
            <v-img :src="libro.img" width="100%">
              <!--<div class="downloadcuento">
                <v-card-actions >
                  <a @click="downloadItem(cuento.url,cuento.namedownload)">
                    <img class="download hidden-sm-and-down" src="descargar.png" style="border:solid 2px white;" >
                    <img src="descargar.png" class="download hidden-md-and-up" style="border:solid 2px white;" width="50px" >
                  </a>
                </v-card-actions>
              </div>-->
            </v-img>
           </a>
          </v-card>

        </v-flex>
      </v-layout>
    
    </v-container>
  </v-flex>
</template>


<script type="text/javascript" src="https://cdnjs.cloudflare.com/ajax/libs/jquery/3.2.1/jquery.min.js"></script>
<script type="text/javascript" src="http://pdf-to-flipbook.codingfocus.com/release/jquery.pdfflipbook.1.js"></script>

<script type="text/javascript">
       $('a').pdfFlipbook();</script>


<script>
  import Navbar from "@/components/Navbar.vue"
  import axios from 'axios'
 
  export default {
    props:['libros'],

    components:{
       Navbar
     },
    data(){
      return{
        searchstory:"",
      }
    },
    methods:{
        downloadItem (url,name) {
        axios.get(url, { responseType: 'blob' })
          .then(({ data }) => {
            const blob = new Blob([data], { type: 'application/pdf' })
            let link = document.createElement('a')
            link.href = window.URL.createObjectURL(blob)
            link.download = name
            link.click()
          }).catch(error => console.error(error))
        }
        
},
    computed: {
      filterLibros: function(){
        if (this.searchstory=="") {
          return this.libros
        }else{
          return this.libros.filter((libro)=>{
            var expresion = new RegExp(this.searchbook,"i")
            return libro.title.match(expresion)
          })
        }      
      }
  }


    
  }
</script>


<style scoped >

.temacuento{
    background-color:white; 
    color: gray;
    font-family: "Poppins";
    font-weight: 500;
  }
   /*@media (min-width: 1200px)and (max-width: 1300px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:78%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -95px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 125px;
  }
}*/
  
  /*@media (min-width: 1300px)and (max-width: 1500px){
  input[type=text] {
    background-color:white;
    width:82%;
    font-size:18px;
    height:78%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -100px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 150px;
  }
}*/

/*@media (min-width: 1500px) and (max-width: 2000px){
  input[type=text] {
    background-color:white;
    width:82%;
    font-size:18px;
    height:70%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
     margin-right: -110px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 160px;
  }
}*/

/*@media (min-width: 2000px){
  input[type=text] {
    background-color:white;
    width:80%;
    font-size:18px;
    height:65%;
    padding: 12px 20px;
    border-radius:6px;
    float:right;
    margin-right: -135px;
  }

  .imgbuscador{
    position:absolute;
    margin-left: 245px;
  }
}*/

  
@media (min-width: 750px){
  .temacuento{
    font-size: 1.5vw; 
    
  }

}

/*@media (min-width: 750px) and (max-width: 1000px){
    input[type=text] {
    background-color:white;
    width:110%;
    font-size:18px;
    height:85%;
    padding: 12px 20px;
    border-radius:6px;
    margin-left: -50px;
    
  }


  .imgbuscador{
    position:absolute;
    margin-left: -107px;
  }
  }*/

/*@media (min-width: 1000px) and (max-width: 1200px){
     input[type=text] {
    background-color:white;
    width:115%;
    font-size:18px;
    height:85%;
    padding: 12px 20px;
    border-radius:6px;
    float: right;
    margin-right: -130px;
    
  }


  .imgbuscador{
    position:absolute;
    margin-left: 45px;
  }
  }*/

@media (min-width: 300px) and (max-width: 750px){
  .temacuento{
    font-size: 4vw; 
    
  }

  /*input[type=text] {
    background-color:white;
    width:70%;
    font-size:18px;
    height:100%;
    padding: 12px 20px;
    border-radius:6px;
    top:-30px;
    margin-left: 40px;
   
  }

  .imgbuscador{
    position:absolute;
    margin-left: -15px;
  }*/
}

.downloadcuento{
  
  position: absolute; bottom:-14px; right: -8px;

}

  .download:hover {
  transform: scale(1.2); /* (150% zoom - Note: if the zoom is too large, it will go outside of the viewport) */
}
</style>
